import React, { Fragment } from "react";
import cn from "classnames";
import "./StatisticBarChart.sass";

export const CustomTooltip = ({ active, payload, currency, eventsList = [] }) => {
  if (active && payload && payload[0].payload.amount !== 0) {
    const { amount, ticketsInfo } = payload[0].payload;
    const totalPaid = ticketsInfo.reduce((acc, value) => acc + value.totalPaid, 0);

    return (
      <div
        className={
          cn('chart-custom-tooltip', {
            'chart-custom-tooltip--col-3': !eventsList.length,
          })
        }>
      <div>
          <strong>Ticket name</strong>
        </div>
        {eventsList.length > 0 && (
          <div>
            <strong>Event name</strong>
          </div>
        )}
        <div>
          <strong>Amount</strong>
        </div>
        <div>
          <strong>Total paid, {currency}</strong>
        </div>

        {ticketsInfo.map(info => (
          <Fragment key={info.name}>
            <div>{info.name}</div>
            {eventsList.length > 0 && (
              <div>{eventsList.find(e => e.value === info.eventId).label}</div>
            )}
            <div>{info.amount}</div>
            <div>{info.totalPaid}</div>
          </Fragment>
        ))}

        {ticketsInfo.length > 1 && (
          <>
            <div>
              <strong>Total</strong>
            </div>
            {eventsList.length > 0 && (
              <div></div>
            )}
            <div>
              <strong>{amount}</strong>
            </div>
            <div>
              <strong>{totalPaid}</strong>
            </div>
          </>
        )}
      </div>
    );
  }

  return null;
};
